import { render, staticRenderFns } from "./KBSearch.vue?vue&type=template&id=53988638&scoped=true&"
import script from "./KBSearch.vue?vue&type=script&lang=js&"
export * from "./KBSearch.vue?vue&type=script&lang=js&"
import style0 from "./KBSearch.vue?vue&type=style&index=0&id=53988638&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53988638",
  null
  
)

export default component.exports